import { page, getById } from '@/api/ship/shipInstance'
import optionsMixin from '../mixins/optionsMixin'

export default optionsMixin(page, getById)
